import { useLanguage } from "../i18n/LanguageContext";
import { Reveal } from "../components/Motion";
import { PageHeader } from "../components/Detail";

const LegalPageShell = ({ title, blocks, testId }) => (
  <main id="main-content">
    <PageHeader overline="Naciye Rafiq-Arli" title={title} overlineTestId={`${testId}-overline`} />
    <div className="mx-auto max-w-3xl px-5 py-14 sm:px-8" data-testid={`${testId}-content`}>
      {blocks.map((block, i) => (
        <Reveal key={i} delay={i * 0.03}>
          <section className="mb-10">
            <h2 className="font-display text-xl font-semibold tracking-tight text-petrol sm:text-2xl">{block.h}</h2>
            <div className="mt-3 space-y-3 leading-relaxed text-slate2">
              {block.paras.map((p, j) => (
                <p key={j} className="whitespace-pre-line">{p}</p>
              ))}
            </div>
          </section>
        </Reveal>
      ))}
    </div>
  </main>
);

export function Impressum() {
  const { t } = useLanguage();
  return <LegalPageShell title={t.legal.imprintTitle} blocks={t.legal.imprintBlocks} testId="impressum" />;
}

export function Datenschutz() {
  const { t } = useLanguage();
  return <LegalPageShell title={t.legal.privacyTitle} blocks={t.legal.privacyBlocks} testId="datenschutz" />;
}
